import { connect } from 'react-redux';

import { IAppState } from '../../../common/state';
import { Newobjects } from './index';

export const NewobjectsContainer = connect(
  (state: IAppState) => ({
    similarNewobjects: state.similarNewobjects,
    aggregatedOffers: state.results.aggregatedOffers,
  }),
  // tslint:disable-next-line: no-any
)(Newobjects as any);
